import * as XLSX from "xlsx-js-style";

export const exportToExcel = ({ nfsaType, month, year, commodities, commCodes, summaryData, totals, refreshTime }) => {
  const wsData = [];

  const title = [
    {
      v: `${nfsaType === "N" ? "NFSA" : "Non-NFSA"} Sale Abstract (in MTs)`,
      s: { font: { bold: true, sz: 14 }, alignment: { horizontal: "center" } }
    }
  ];
  wsData.push(title);

  const headerRow = ["Allotted Month/Year", ...commCodes.map(code => commodities.find(c => c.commId === code)?.commName ?? code)];
  wsData.push(headerRow.map(text => ({
    v: text,
    s: { font: { bold: true, color: { rgb: "000000" } }, alignment: { horizontal: "center" } } 
  })));

  summaryData.forEach(row => {
    const dataRow = [`${month}/${year}`];
    commCodes.forEach(code => dataRow.push(row.dynamicFields?.[`comm_code_${code}`] ?? 0));
    wsData.push(dataRow);
  });

  const totalRow = ["Total"];
  commCodes.forEach(code => totalRow.push(totals[code]));
  wsData.push(totalRow.map(text => ({
    v: text,
    s: { font: { bold: true, color: { rgb: "000000" } }, alignment: { horizontal: "center" } } 
  })));

  const refreshRowData = new Array(headerRow.length).fill("");
  refreshRowData[headerRow.length - 2] = { v: "Refresh Time :", s: { font: { color: { rgb: "FF0000" }, bold: true }, alignment: { horizontal: "right" } } };
  refreshRowData[headerRow.length - 1] = { v: refreshTime, s: { font: { color: { rgb: "008000" }, bold: true }, alignment: { horizontal: "left" } } };
  wsData.push(refreshRowData);

  const ws = XLSX.utils.aoa_to_sheet(wsData);

  ws["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: headerRow.length - 1 } }
  ];

  ws["!merges"].push({ s: { r: wsData.length - 1, c: 0 }, e: { r: wsData.length - 1, c: headerRow.length - 3 } });

  ws["!cols"] = headerRow.map(() => ({ wch: 20 }));

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sale Summary");
  XLSX.writeFile(wb, `${nfsaType === "N" ? "NFSA" : "Non-NFSA"}_Sale_Summary_${month}_${year}.xlsx`);
};
